export default {
  title: "Pais"
  , form: {
    codigo: {
      label: "Código País"
      , th: "Código País"
    }
    , nombre: {
      label: "Nombre"
      , th: "Nombre"
    }
    , lada: {
      label: "País"
      , th: "País"
    }
  }
  , errors: {
    BD6003: { text: "Ocurrió un error en el catálogo de Pais" }
    , WS6003: { text: "Ocurrió un error en el catálogo de Pais" }
    , JS6003: { text: "Ocurrió un error en el catálogo de Pais" }
    , C56003: { text: "Ocurrió un error en el catálogo de Pais" }
    , UK_Pais: { text: "Ya existe un registro con el mismo código" }
  }
}


// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/geograficos/pais.js